// Terms of Service 页面组件 - 简洁白色样式
import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const TermsOfService: React.FC = () => {
  const { t } = useTranslation()
  
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* 头部导航 */}
        <div className="mb-8">
          <Link 
            to="/register" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('termsOfService.backToRegister')}
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">{t('termsOfService.title')}</h1>
          <p className="text-gray-600 mt-2">
            {t('termsOfService.lastUpdated')}: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* 内容 */}
        <div className="prose max-w-none">
          <div className="space-y-8 text-gray-800">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.serviceDescription.title')}</h2>
              <p className="mb-4">
                {t('termsOfService.serviceDescription.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.userResponsibilities.title')}</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>{t('termsOfService.userResponsibilities.item1')}</li>
                <li>{t('termsOfService.userResponsibilities.item2')}</li>
                <li>{t('termsOfService.userResponsibilities.item3')}</li>
                <li>{t('termsOfService.userResponsibilities.item4')}</li>
                <li>{t('termsOfService.userResponsibilities.item5')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.paymentBilling.title')}</h2>
              <p className="mb-4">
                {t('termsOfService.paymentBilling.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.apiUsageTerms.title')}</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>{t('termsOfService.apiUsageTerms.item1')}</li>
                <li>{t('termsOfService.apiUsageTerms.item2')}</li>
                <li>{t('termsOfService.apiUsageTerms.item3')}</li>
                <li>{t('termsOfService.apiUsageTerms.item4')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.intellectualProperty.title')}</h2>
              <p className="mb-4">
                {t('termsOfService.intellectualProperty.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.serviceModifications.title')}</h2>
              <p className="mb-4">
                {t('termsOfService.serviceModifications.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('termsOfService.contactInfo.title')}</h2>
              <p className="mb-4">
                {t('termsOfService.contactInfo.content')}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService